import { useGlobalState } from '@/hooks';
import type { ContentItemInterface } from '@/interfaces';
import Image from 'next/image';
import type { FC } from 'react';
import {
  ImageWrapper,
  ServiceSubTitle,
  ServiceTitle,
  ServicesButton,
  ServicesContainer,
  ServicesContentWrapper,
} from './Services.styles';

const Services: FC<ContentItemInterface> = ({
  title,
  longSubTitle,
  image,
  wrapperImage,
  buttonText,
  buttonLink,
  openInNewTab,
}) => {
  const serviceImage = wrapperImage || image;
  const { getProperImageUrl, t } = useGlobalState();
  const translatedTitle = t(title ?? '');
  const translatedLongSubTitle = t(longSubTitle ?? '');
  const translatedButtonText = t(buttonText ?? '');
  return (
    <ServicesContainer>
      {serviceImage && (
        <ImageWrapper>
          <Image
            src={getProperImageUrl(serviceImage)}
            alt={serviceImage.description}
            quality={100}
            fill
            sizes='100vw'
            style={{
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        </ImageWrapper>
      )}
      <ServicesContentWrapper>
        <ServiceTitle>{translatedTitle}</ServiceTitle>
        {longSubTitle && <ServiceSubTitle>{translatedLongSubTitle}</ServiceSubTitle>}
        {buttonText && buttonLink && (
          <ServicesButton href={buttonLink} target={openInNewTab ? '_blank' : '_self'}>
            {translatedButtonText}
          </ServicesButton>
        )}
      </ServicesContentWrapper>
    </ServicesContainer>
  );
};

export default Services;
